import { secureApiPut, secureApiDelete } from '../secureHttp';
import type { ScheduleType } from './list';

export type PsychologistWorkScheduleUpdateInput = {
  weekday?: number;
  start_time?: string;
  end_time?: string;
  active?: boolean;
  skip_slot_management?: boolean;
  schedule_type?: ScheduleType;
};

export async function updatePsychologistWorkSchedule(scheduleId: string, data: PsychologistWorkScheduleUpdateInput) {
  return await secureApiPut(`/v1/psi-platform/psychologist/calendar/work-schedules/${scheduleId}`, data);
}

export async function deletePsychologistWorkSchedule(scheduleId: string, options?: { preserve_slots?: boolean }) {
  const query = options?.preserve_slots ? '?preserve_slots=true' : '';
  return await secureApiDelete(`/v1/psi-platform/psychologist/calendar/work-schedules/${scheduleId}${query}`);
}


